import React from 'react';
import { Button, Result, Space } from 'antd';
import { useNavigate } from 'react-router-dom';

// Le bouton « Retour à l'accueil » DÉCONNECTAIT l'utilisateur (il écrasait
// persist:root puis renvoyait sur /login). Une URL mal tapée coûtait la
// session. Désormais : accueil ou page précédente, session intacte.
const Page404 = () => {
  const navigate = useNavigate();

  return (
    <Result
      status="404"
      title="404"
      subTitle="Désolé, la page que vous avez visitée n'existe pas."
      extra={(
        <Space wrap>
          <Button onClick={() => navigate(-1)}>← Page précédente</Button>
          <Button type="primary" onClick={() => navigate('/')}>Retour à l'accueil</Button>
        </Space>
      )}
    />
  );
};

export default Page404;
